<template>
  <v-layout row
            wrap>
    <v-flex xs12>
      <crud resource="deliveryItems"
            :manager="manager"
            :filters="filters"
            :custom-view-dialog="true"
            :creatable="false"
      />
    </v-flex>
    <!--View Dialog - Custom View-->
    <v-dialog v-model="viewDialogHere" max-width="1000px">
      <v-card v-if="item">
        <v-card-text>
          <connection-manager ref="connectionManager"
                              v-model="connecting"/>
          <v-data-table
            hide-headers
            hide-actions
            :headers="viewItemHeaders"
            :items="viewableHeaders">
            <template slot="items"
                      slot-scope="props">
              <td>{{props.item.text}}</td>
              <td>{{manager.toValue(props.item, item)}}</td>
            </template>
          </v-data-table>
          <v-data-table
            :items="item.stops"
            hide-actions
            item-key="id"
            :style="'max-height: '+($vuetify.breakpoint.height * 0.30)+'px;'"
            class="scroll-y"
            :headers="itemHeaders">
            <template slot="items" slot-scope="props">
              <td>{{props.item.type}}</td>
              <td>{{props.item.stopName}}</td>
              <td>{{props.item.stopVicinity}}</td>
              <td>{{props.item.stopFormattedAddress}}</td>
              <td>{{props.item.stopLatitude}}</td>
              <td>{{props.item.stopLongitude}}</td>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="red darken-1"
                 flat
                 :disabled="connecting"
                 @click.native="close">
            Close
          </v-btn>
          <v-spacer/>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
  import Crud from './Crud'
  import CrudBase from './CrudBase.vue'
  import ConnectionManager from './ConnectionManager'

  export default {
    name: 'DeliveryItems',
    extends: CrudBase,
    components: {ConnectionManager, Crud},
    data () {
      return {
        item: null,
        viewDialogHere: false,
        connecting: false,
        viewableHeaders: [],
        viewItemHeaders: [],
        itemHeaders: [
          {text: 'Type', value: 'item.type'},
          {text: 'Name', value: 'item.stopName'},
          {text: 'Vicinity', value: 'item.stopVicinity'},
          {text: 'Address', value: 'item.stopFormattedAddress'},
          {text: 'Stop Latitude', value: 'item.stopLatitude'},
          {text: 'Stop Longitude', value: 'item.stopLongitude'}
        ],
        filters: [
          {value: 'PENDING_PICKUP', name: 'Pending Pickup'},
          {value: 'EN_ROUTE_TO_DESTINATION', name: 'On Progress'},
          {value: 'AT_DESTINATION', name: 'At Destination'}
        ]
      }
    },
    methods: {
      close () {
        this.item = null
        this.viewDialogHere = false
      },
      initialize () {
        let that = this
        this.manager.editable = (item) => {
          return false
        }
        this.manager.deletable = (item) => {
          return false
        }
        this.manager.creatable = () => {
          return false
        }
        this.manager.toValue = (header, item) => {
          if (header.value === 'courierOptionName') {
            return item.courierOption ? item.courierOption.name : that.defaultValue
          } if (header.value === 'deliveryRider') {
            if (item.delivery) {
              return item.delivery.rider ? item.delivery.rider.name + ' - ' + item.delivery.rider.phone : that.defaultValue
            } else {
              return ''
            }
          } if (header.value === 'addressDetails') {
            return item.delivery ? item.delivery.addressDetails : that.defaultValue
          } if (header.value === 'pickupLocation') {
            return item.delivery ? item.delivery.originName : that.defaultValue
          } if (header.value === 'deliveryClient') {
            return item.delivery ? item.delivery.user.client.name : that.defaultValue
          } if (header.value === 'scheduled') {
            return item.delivery ? `${item.delivery.scheduleDate}-${item.delivery.scheduleTime}` : that.defaultValue
          } if (header.value === 'bookedBy') {
            return item.delivery ? `${item.delivery.user.name}-${item.delivery.user.phone}` : that.defaultValue
          } if (header.value === 'urgency') {
            if (item.delivery) {
              if (item.delivery.urgent === 1) {
                return 'Urgent'
              } else {
                return 'Non-Urgent'
              }
            }
          } if (header.value === 'pickupAddress') {
            return item.delivery ? item.delivery.originFormattedAddress : that.defaultValue
          } if (header.value === 'estimatedDeliveryCost') {
            return that.$app.formatMoney(item.estimatedDeliveryCost)
          } if (header.value === 'deliveryCost') {
            return that.$app.formatMoney(item.deliveryCost)
          } if (header.value === 'stopTime') {
            return that.$app.timeToMin(item.stopTime)
          } if (header.value === 'timeTaken') {
            return that.$app.timeToMin(item.timeTaken)
          } if (header.value === 'totalDistance') {
            return that.$app.distanceToKm(item.totalDistance)
          } else {
            return item[header.value] ? item[header.value] : that.defaultValue
          }
        }
        this.manager.nameOnDelete = (item) => {
          return 'this order.'
        }
        this.manager.hasCustomView = (item, viewableHeaders, viewItemHeaders) => {
          that.item = item
          this.$app.log('The items are ' + item.stops)
          that.viewDialogHere = true
          that.viewableHeaders = viewableHeaders
          that.viewItemHeaders = viewItemHeaders
          return true
        }
        this.manager.showInlineAction = (action, item, filter) => {
          if (action.key === 'dispatch' && filter) {
            return filter.value === 'PENDING_DISPATCH' && (this.isAdmin() || this.isOperations())
          }
          if (action.key === 'confirmReceived' && filter) {
            return filter.value === 'DISPATCHED' && this.isDepartmentUser()
          } else {
            return true
          }
        }
        this.manager.showTopAction = (action, items, filter) => {
          if ((action.key === 'approveAll' || action.key === 'rejectAll') && filter) {
            return ((filter.value === 'AT_DEPARTMENT_HEAD' && this.isDepartmentHead()) ||
              (filter.value === 'AT_PURCHASING_HEAD' && this.isPurchasingHead())) && items.length
          } else {
            return true
          }
        }
        this.manager.onTopAction = (action, items, filter) => {
          if (action.key === 'approveAll' || action.key === 'rejectAll') {
            this.$refs.connectionManager.patch('orders/' + action, {
              onSuccess (response) {
                that.$refs.crud.clearItems()
              }
            })
          }
        }
        this.manager.onInlineActionClicked = (action, item, filter) => {
          if (action.key === 'view') {
            that.$refs.crud.viewItem(item)
          } else if (action.key === 'dispatch') {
            that.viewableHeaders = that.$refs.crud.viewableHeaders
            that.viewItemHeaders = that.$refs.crud.viewItemHeaders
            that.dispatchingItem = item
            that.dispatching = true
          } else if (action.key === 'confirmReceived') {
            that.viewableHeaders = that.$refs.crud.viewableHeaders
            that.viewItemHeaders = that.$refs.crud.viewItemHeaders
            that.confirmingReceivedItem = item
            that.confirmingReceived = true
          }
        }
        this.manager.hideHeader = (header, filter) => {
          // if (header.value === 'destinationName' || header.value === 'destinationFormattedAddress') {
          //   return filter.value === 'PENDING_PICKUP'
          // } else {
          //   return false
          // }
        }

        this.manager.fireAction = (action, item) => {
          that.$app.log(action.key)
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/DeliveryItems.vue